import {InputElementType, Validation, type ValidationConfig, type ValidationResponse, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";
import {LocalDate} from "../../../common/utils/dates/localDate";

export type ValidDateConfig = ValidationConfig & {
    id: "validDate";
};

export class ValidDate extends Validation {

    private constructor(
        messageText: string,
        warningLevel: WarningLevel
    ) {
        super(messageText, warningLevel);
    }

    public static from(config: ValidDateConfig): ValidDate {
        return new ValidDate(config.message, config.warningLevel);
    }

    protected valid(value: unknown): boolean {
        if (value === "") {
            return true;
        }
        const dateFromExpression = LocalDate.fromDateExpression(value as string);
        return dateFromExpression.isValid();
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value: T): void {
        inputElement.setType(InputElementType.DATE);
        const input = inputElement.querySelector("input");
        if (input && input.validity.badInput) {
            inputElement.addMessage({warningLevel: this.warningLevel, message: this.errorText});
        }

        const validationResponse: ValidationResponse = this.checkValidity(value);
        if (!validationResponse.valid) {
            inputElement.addMessage({warningLevel: validationResponse.warningLevel, message: this.errorText});
        }
    }
}